// import React, { useState } from 'react'
// import { useLocation, useNavigate } from "react-router-dom";
// import Banner from '../common/Banner'
// import serviceData from "../../data/service.json";
// import images from '../../assets/images/Constant'
// import WhyChooseUs from '../Home/WhyChooseUs';
// import EasySteps from '../Home/EasySetps';

// const Service = () => {

//   const location = useLocation();
//   const navigate = useNavigate();

//   // ✅ ROUTE CHECK (FINAL FIX)
//   const isServicePage = location.pathname.startsWith("/service");
// //   const isServicePage = location.pathname === "/service";
//   const isHomePage =
//     location.pathname === "/" || location.pathname === "/home";

//   // ✅ DATA
//   const servicesSection = serviceData?.section || {};
//   const services = Array.isArray(serviceData?.services)
//     ? serviceData.services
//     : [];

//   const [index, setIndex] = useState(0);

//   // ✅ FINAL DISPLAY LOGIC
//   let visibleServices = [];

//   if (isServicePage) {
//     visibleServices = services; // 👉 ALL 9
//   } else if (isHomePage) {
//     visibleServices = services.slice(index * 3, index * 3 + 3); // 👉 ONLY 3
//   } else {
//     visibleServices = []; // 👉 DETAILS PAGE
//   }

//   const totalDots = Math.ceil(services.length / 3);

//   return (
//     <>
//       {/* ✅ Banner only on service page */}
//       {isServicePage && (
//         <Banner
//           title={serviceData?.banner?.title || "Service"}
//           currentLabel={serviceData?.banner?.breadcrumb || "Service"}
//         />
//       )}

//       <section className="bg-white pt-16 md:py-20">
//         <div className="max-w-[1200px] mx-auto text-center px-6">

//           {/* Heading */}
//           <div className="flex gap-2 justify-center items-center">
//             <img src={images[servicesSection.icon]} alt="" />
//             <p className="text-primary font-medium text-[18px] md:text-[22px]">
//               {servicesSection.subtitle}
//             </p>
//           </div>

//           <h2 className="text-2xl md:text-subheading font-semibold mt-2 text-dark">
//             {servicesSection.title}
//           </h2>

//           {/* Cards */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">

//             {visibleServices.map((service, i) => (
//               <div key={i} className="bg-[#F4F4F4] shadow-md relative">

//                 <img
//                   src={images[service.image]}
//                   alt={service.title}
//                   className="w-full h-48 md:h-56 object-cover"
//                 />

//                 <div className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2">
//                   <img
//                     src={images[service.icon]}
//                     alt="icon"
//                     className="w-12 h-12 md:w-16 md:h-16"
//                   />
//                 </div>

//                 <div className="p-6 pt-10">
//                   <h3 className="text-lg md:text-subheading font-semibold">
//                     {service.title}
//                   </h3>

//                   <p className="text-description text-light text-sm md:text-base">
//                     {service.description}
//                   </p>

//                   <button
//                     onClick={() => navigate(`/service/${service.id}`)}
//                     className="mt-4 border border-primary text-primary px-6 py-2"
//                   >
//                     MORE DETAILS
//                   </button>
//                 </div>

//               </div>
//             ))}

//           </div>

//           {/* ✅ Slider dots only on home */}
//           {isHomePage && (
//             <div className="flex justify-center gap-3 mt-6">
//               {[...Array(totalDots)].map((_, dotIndex) => (
//                 <span
//                   key={dotIndex}
//                   onMouseEnter={() => setIndex(dotIndex)}
//                   className={`w-3 h-3 md:w-4 md:h-4 rounded-full cursor-pointer 
//                   ${index === dotIndex ? "bg-primary" : "bg-secondary"}`}
//                 ></span>
//               ))}
//             </div>
//           )}

//         </div>
//       </section>
//       {/* ✅ Only Service Page */}
// {isServicePage && (
//   <>
//     <WhyChooseUs />
//     <EasySteps />
//   </>
// )}
//     </>
//   )
// }

// export default Service;



import React, { useEffect, useState, useRef, useCallback } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import Banner from '../common/Banner'
import serviceData from "../../data/service.json";
import images from '../../assets/images/Constant'
import WhyChooseUs from '../Home/WhyChooseUs';
import EasySteps from '../Home/EasySetps';

const Service = () => {

  const location = useLocation();
  const navigate = useNavigate();

  // ✅ ROUTE CHECK
  const isServicePage = location.pathname.startsWith("/service");
  const isHomePage =
    location.pathname === "/" || location.pathname === "/home";

  // ✅ DATA
  const servicesSection = serviceData?.section || {};
  const services = Array.isArray(serviceData?.services)
    ? serviceData.services
    : [];

  // ✅ SLIDER STATE
  const [index, setIndex] = useState(services.length);
  const viewportRef = useRef(null);
  const [viewportWidth, setViewportWidth] = useState(0);
  const [slidesPerView, setSlidesPerView] = useState(1);

  const updateSlidesPerView = useCallback(() => {
    const w = window.innerWidth;
    if (w >= 1024) setSlidesPerView(3);
    else if (w >= 640) setSlidesPerView(2);
    else setSlidesPerView(1);
  }, []);

  useEffect(() => {
    updateSlidesPerView();
    window.addEventListener("resize", updateSlidesPerView);
    return () => window.removeEventListener("resize", updateSlidesPerView);
  }, [updateSlidesPerView]);

  useEffect(() => {
    if (!isHomePage) return;
    const el = viewportRef.current;
    if (!el) return;
    const ro = new ResizeObserver(() => setViewportWidth(el.clientWidth));
    ro.observe(el);
    setViewportWidth(el.clientWidth);
    return () => ro.disconnect();
  }, [isHomePage]);

  const slideWidth =
    viewportWidth > 0 && slidesPerView > 0
      ? viewportWidth / slidesPerView
      : 0;

  // loop create (infinite feel)
  const loopServices = [...services, ...services, ...services];

  // auto slide
  useEffect(() => {
    if (!isHomePage) return;

    const interval = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 3000);

    return () => clearInterval(interval);
  }, [isHomePage]);

  // reset for loop
  useEffect(() => {
    if (index >= services.length * 2) {
      setTimeout(() => {
        setIndex(services.length); // middle pe reset
      }, 0);
    }
  }, [index, services.length]);

  return (
    <>
      {/* ✅ Banner */}
      {isServicePage && (
        <Banner
          title={serviceData?.banner?.title || "Service"}
          currentLabel={serviceData?.banner?.breadcrumb || "Service"}
        />
      )}

      <section className="bg-white pt-16 md:py-20">
        <div className="max-w-[1200px] mx-auto text-center px-6">

          {/* Heading */}
          <div className="flex gap-2 justify-center items-center">
            <img src={images[servicesSection.icon]} alt="" />
            <p className="text-primary font-medium text-[18px] md:text-[22px]">
              {servicesSection.subtitle}
            </p>
          </div>

          <h2 className="text-2xl md:text-subheading font-semibold mt-2 text-dark">
            {servicesSection.title}
          </h2>

          {/* ================= HOME SLIDER ================= */}
          {isHomePage ? (
            <div className="overflow-hidden mt-12 -mx-1 sm:mx-0" ref={viewportRef}>

<div
  className={`flex ${index === services.length ? "" : "transition-transform duration-500 ease-out"}`}
  style={{
    transform:
      slideWidth > 0
        ? `translateX(-${index * slideWidth}px)`
        : "translateX(0)",
  }}
>

                {loopServices.map((service, i) => (
                  <div
                    key={`${service.id}-${i}`}
                    className="flex-shrink-0 box-border px-2 sm:px-3"
                    style={{
                      width:
                        slideWidth > 0 ? `${slideWidth}px` : `${100 / Math.max(slidesPerView, 1)}%`,
                    }}
                  >

                    {/* ✅ FIXED CARD */}
                    <div className="bg-[#F4F4F4] shadow-md min-h-[420px] sm:h-[450px] flex flex-col">

                      {/* IMAGE */}
                      <div className="relative">
                        <img
                          src={images[service.image]}
                          alt={service.title}
                          className="w-full h-48 md:h-56 object-cover"
                        />

                        <div className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2">
                          <img
                            src={images[service.icon]}
                            alt="icon"
                            className="w-12 h-12 md:w-16 md:h-16"
                          />
                        </div>
                      </div>

                      {/* CONTENT */}
                      <div className="p-6 pt-10 flex flex-col flex-grow">

                        <div>
                          <h3 className="text-lg md:text-subheading font-semibold">
                            {service.title}
                          </h3>

                          <p className="text-description text-light text-sm md:text-base mt-2 h-[70px] overflow-hidden">
                            {service.description}
                          </p>
                        </div>
<div className='flex justify-center items-center'>
                        <button
                          onClick={() => navigate(`/service/${service.id}`)}
                          className="mt-4 border border-primary text-primary px-6 py-2 self-start"
                        >
                          MORE DETAILS
                        </button>
</div>
                      </div>
                    </div>

                  </div>
                ))}

              </div>
            </div>
          ) : (
            /* ================= SERVICE PAGE GRID ================= */
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">

              {services.map((service, i) => (
                <div key={i} className="bg-[#F4F4F4] shadow-md h-[450px] flex flex-col">

                  {/* IMAGE */}
                  <div className="relative">
                    <img
                      src={images[service.image]}
                      alt={service.title}
                      className="w-full h-48 md:h-56 object-cover"
                    />

                    <div className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2">
                      <img
                        src={images[service.icon]}
                        alt="icon"
                        className="w-12 h-12 md:w-16 md:h-16"
                      />
                    </div>
                  </div>

                  {/* CONTENT */}
                  <div className="p-6 pt-10 flex flex-col flex-grow">

                    <div>
                      <h3 className="text-lg md:text-subheading font-semibold">
                        {service.title}
                      </h3>

                      <p className="text-description text-light text-sm md:text-base mt-2 h-[70px] overflow-hidden">
                        {service.description}
                      </p>
                    </div>

                    <div className='flex justify-center items-center'>
                    <button
                      onClick={() => navigate(`/service/${service.id}`)}
                      className="mt-4 border border-primary text-primary px-6 py-2 self-start"
                    >
                      MORE DETAILS
                    </button>
</div>
                  </div>

                </div>
              ))}

            </div>
          )}

          {/* DOTS */}
          {isHomePage && (
  <div className="flex flex-wrap justify-center gap-3 mt-6">
    {[...Array(Math.ceil(services.length / slidesPerView) || 1)].map((_, dotIndex) => {
      
      const realIndex = index % services.length;
      const activeDot = Math.floor(realIndex / slidesPerView);

      return (
        <span
          key={dotIndex}
          onMouseEnter={() => setIndex(dotIndex * slidesPerView + services.length)} 
          className={`w-3 h-3 rounded-full cursor-pointer 
          ${activeDot === dotIndex ? "bg-primary" : "bg-secondary"}`}
        ></span>
      );
    })}
  </div>
)}

        </div>
      </section>

      {/* ✅ ONLY SERVICE PAGE EXTRA SECTIONS */}
      {isServicePage && (
        <>
          <WhyChooseUs />
          <EasySteps />
        </>
      )}

    </>
  )
}

export default Service;